module.exports = __webpack_public_path__ + "static/img/icon_artexp_label.a9ebb114.png";